(function() {
    /* globals $, angular */
    'use strict';

    angular.module("dashboardApp").directive("imsUsageTrackerChart", Directive);

    Directive.$inject = [
    ];



    function Directive(
    ) {


        function link(scope, element) {

            scope.chartData = null;


            function drawChart(data) {
                var categories = [];
                var series = { name: 'Logins', data: [] };

                _.forEach(data, function(row) {
                    categories.push(row.date);
                    series.data.push(row.value);
                });

                $(element).highcharts({
                    chart: {
                        type: 'column'
                    },
                    title: null,
                    plotOptions: {
                        series: {
                            dataLabels: {
                            align: 'center',
                            enabled: true
                            }
                        }
                    },
                    xAxis: {
                        categories: categories
                    },
                    yAxis: [
                        {
                            title: { text: 'Count' }
                        }
                    ],
                    series: [series]
                });

            }


            function init() {
                scope.$watch('loginCounts', function(data) {
                    if (data) {
                        drawChart(data);
                    }
                });
            }


            init();

        }



        return {
            restrict: 'E',
            replace: true,
            scope: {
                loginCounts: '='
            },
            template:  '<div class="chart"></div>',
            link: link
        };



    }


})();
